import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const PARTNERPLAN_REMINDERS_GET = 'PARTNERPLAN_REMINDERS_GET'
export const PARTNERPLAN_REMINDERS_RECEIVED = 'PARTNERPLAN_REMINDERS_RECEIVED'
export const PARTNERPLAN_REMINDERS_GET_ERROR = 'PARTNERPLAN_REMINDERS_GET_ERROR'
export const PARTNERPLAN_REMINDERS_SEND_RECEIVED = 'PARTNERPLAN_REMINDERS_SEND_RECEIVED'
export const PARTNERPLAN_REMINDERS_SEND_COMPLETE = 'PARTNERPLAN_REMINDERS_SEND_COMPLETE'
export const PARTNERPLAN_REMINDERS_SEND_ERROR = 'PARTNERPLAN_REMINDERS_SEND_ERROR'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const sendReminderNotificationRequest = () => ({
  type: PARTNERPLAN_REMINDERS_SEND_RECEIVED,
})

const sendReminderNotificationComplete = reminderNotifications => ({
  type: PARTNERPLAN_REMINDERS_SEND_COMPLETE,
  reminderNotifications,
})

const partnerPlanReminderReceive = reminderNotifications => ({
  type: PARTNERPLAN_REMINDERS_RECEIVED,
  reminderNotifications,
})

export function getPartnerplanReminderEmailToBeSent(employeeId) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLAN_REMINDERS_GET))
    agent.PartnerPlans.getpartnerplanreminderemail(employeeId).then((response) => {
      if (response.length > 0) {
        dispatch(partnerPlanReminderReceive(response))
      }
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getPartnerplanReminderEmailToBeSent>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_REMINDERS_GET_ERROR))
      }
    })
  }
}

export function sendPartnerplanReminderEmail(employeeId, selectedEmployeeId, planStatus, runTest) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLAN_REMINDERS_SEND_RECEIVED))
    agent.PartnerPlans.sendpartnerplanreminderemail(employeeId, selectedEmployeeId, planStatus, runTest).then((response) => {
      if (response.length > 0) {
        dispatch(sendReminderNotificationComplete(response))
        const reminderSent = response.filter(reminder => reminder.emailSent === 1).map(email => ({
          partnerName: email.partnerName,
          partnerEmail: email.partnerEmail,
          emailSent: email.emailSent,
          infoMessage: email.infoMessage,
          datestamp: email.datestamp,
        }))
        if (reminderSent.length === 0) {
          dispatch(notify('Unable to send reminder email, please check the logs for error.'))
          return
        }
        dispatch(notify(`Reminder sucessfully sent for ${reminderSent.length} Partners`))
      }
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <sendPartnerplanReminderEmail>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_REMINDERS_SEND_ERROR))
      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/actions/partnerPlanReminderNotification.js